import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import { CHARGE_PHASE, COMBAT_PHASE, DURING_GAME, HERO_PHASE, SAVES_PHASE, SHOOTING_PHASE, START_OF_ROUND } from 'types/phases'

const CommandTraits = {
 /* 'Show of Superiority': {
    effects: [
      {
        name: `Show of Superiority`,
        desc: `While this general is on the battlefield, roll a dice before your opponent spends any command points to use a command ability. On a 5+, your opponent must spend 2 command points to issue the command instead of 1.`,
        when: [DURING_GAME],
      },
    ],
  },
  'Crafted from Beast-bone': {
    effects: [
      {
        name: `Crafted from Beast-bone`,
        desc: `After this general has fought for the first time, at the start of each battle round, add 1 to the Attacks characteristic of this general's weapons for the rest of the battle. This effect is cumulative.`,
        when: [START_OF_ROUND],
      },
    ],
  },
  'Aura of Sterility': {
    effects: [
      {
        name: `Aura of Sterility`,
        desc: `Subtract 1 from hit rolls and wound rolls for attacks made with missile weapons that target friendly OSSIARCH BONEREAPERS units wholly within 12" of this general.`,
        when: [SHOOTING_PHASE],
      },
    ],
  }, */
  'Manufactured Mind': {
    effects: [
      {
        name: `Manufactured Mind - Once Per Battle`,
        desc: `Effect: When picking a friendly Ossiarch Bonereapers Hero to be the target of the Immortal Elite ability this battle round, you can pick a friendly Ossiarch Bonereapers Hero that has been destroyed.`,
        when: [START_OF_ROUND],
      },
    ],
  },
  'Immaculate Defender': {
    effects: [
      {
        name: `Immaculate Defender - Passive`,
        desc: `Effect: Ignore the first damage point allocated to each friendly Ossiarch Bonereapers Infantry unit in the combat phase while they are wholly within 12" of this unit.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Imperious Will': {
    effects: [
      {
        name: `Imperious Will - Reaction: You declared a Fight ability for a non-Hero Ossiarch Bonereapers unit wholly within 12" of this unit`,
        desc: `Effect: Pick an enemy unit in combat with that non-Hero unit and that did not charge this turn to be the target. Roll a D3. On a 2+, inflict an amount of mortal damage on the target equal to the roll. This unit can use this ability more than once per phase.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'The Lance of Ossia (AoR)': {
    effects: [
      {
        name: `Prevailing Tactician (AoR)`,
        desc: `Effect: If a friendly Arch-Kavalos Zandtos is not wholly within 12" of this unit, you gain 2 relentless discipline points.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'The Null Myriad (AoR)': {
    effects: [
      {
        name: `Aura of Enervation (AoR) - Passive`,
        desc: `Effect: Subtract 1 from wound rolls for shooting attacks that target friendly Null Myriad units while they are wholly within 12" of this unit.`,
        when: [SHOOTING_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(CommandTraits, 'command_trait')
